import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class SourceOfResourcesIsNotOnRange extends HundredBricksAPIError {
    constructor(options) {
        super('The source of the resource is not within the allowed character range', options);
    }
}
export default SourceOfResourcesIsNotOnRange;
